<template>
  <div style="padding-bottom: 70px;">
    <el-form label-width="150px" disabled>
      <el-form-item label="收货工站照片:">
        <KfImageViewer :imageList="receiveImageList"/>
      </el-form-item>
      <el-form-item label="收货工站备注:">
        <el-input v-model="receiveData.remark" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="录单工站照片:">
        <KfImageViewer :imageList="inputImageList"/>
      </el-form-item>
      <el-form-item label="录单工站备注:">
        <el-input v-model="inputData.remark" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="产品确认:">
        <el-radio-group v-model="oqcFormData.product">
          <el-radio value="ok">OK</el-radio>
          <el-radio value="ng">NG</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="外观确认:">
        <el-radio-group v-model="oqcFormData.product_vi">
          <el-radio value="ok">OK</el-radio>
          <el-radio value="ng">NG</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="附件确认:" >
        <el-row style="width: 100%;">
          <el-col :span="2" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">附件</el-col>
          <el-col :span="2" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">寄送数量</el-col>
          <el-col :span="2" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">收货数量</el-col>
          <el-col :span="4" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">确认</el-col>
          <el-col :span="18" ></el-col>
        </el-row>
        <div v-for="appendix in oqcFormData.appendixList" :key="appendix.id" style="width: 100%;">
          <el-row style="">
            <el-col :span="2" style="text-align:center;">{{ appendix.appendix_type_name }}</el-col>
            <el-col :span="2" style="text-align:center;">{{appendix.appendix_cnt}}</el-col>
            <el-col :span="2" style="text-align:center;">{{appendix.appendix_receive_cnt}}</el-col>
            <el-col :span="4" style="text-align:center;">
              <el-radio-group v-model="appendix.appendix_result">
                <el-radio value="ok">OK</el-radio>
                <el-radio value="ng">NG</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="18" ></el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="照片:">
        <KfImageViewer :imageList="oqcFormData.oqcImageList" />
      </el-form-item>
    </el-form>
    <FrameForm ref="frameForm" component-param="station_pack" :parent-data="parentData"></FrameForm>
  </div>
</template>

<script>

export default {
  name: "StationPack",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    stationId: String,
  },
  data() {
    return {
      loading: false,
      oqcFormData: {},
      receiveData:[],
      inputData:[],
      receiveImageList:[],
      inputImageList:[],
      oqcImageList:[],
    }
  },
  computed: {},
  created() {
    this.getOqcDetail ()
    this.getReceiveData ()
    this.getInputData ()
  },
  mounted() {
  },
  methods: {

    //获取收货工站照片
    //获取收货工站照片
    async getReceiveData() {
      this.receiveData = await this.$http('buItemService.getReceiveData', {item_id: this.parentData.id,})
      this.receiveImageList = this.receiveData.image_list !== undefined ? this.receiveData.image_list : []
    },

    //获取录单工站照片
    async getInputData() {
      this.inputData = await this.$http('buItemService.getInputData', {item_id: this.parentData.id,})
      this.inputImageList = this.inputData.image_list !== undefined ? this.inputData.image_list : []
    },

    //获取物品OQC工站详情
    async getOqcDetail() {
      this.oqcFormData = await this.$http('buItemService.getOqcDetail', {item_id: this.parentData.id,})
    },
    clearMessage() {
      this.$refs.frameForm.clearMessage()
    },


  }
}
</script>

<style scoped lang="less">

.trouble-form{
  padding: 10px 0 0 0;
  width: 700px;
}

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}

.btn-row {
  padding: 5px 0;
}

.oqcSubmit-row {
  margin: 10px 0;
  padding-top: 0px;
  padding-left: 150px;
  //border-top: 1px solid #ddd;
}
</style>